import {
  PRICING_MARKUP_SCALE,
} from "@/lib/billing/pricing-governance";

export const MINIMUM_RATES_PER_THOUSAND = { image: 1, vector: 0.1 } as const;

// The SQL billing quote uses the same exponential premium above the floor.
export function volumePriceFactor(calls: number, scale = PRICING_MARKUP_SCALE): number {
  const safeCalls = Number.isFinite(calls) && calls > 0 ? calls : 0;
  return Math.exp(-safeCalls / scale);
}
export function dollarRateAtVolume(
  basePerThousand: number,
  calls: number,
  autoTopup: boolean,
  minimumPerThousand: number,
  scale = PRICING_MARKUP_SCALE,
): number {
  const startingRate = Math.max(minimumPerThousand, basePerThousand * (autoTopup ? 0.8 : 1));
  return minimumPerThousand + (startingRate - minimumPerThousand) * volumePriceFactor(calls, scale);
}
